var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 177,
    viewBox: "0 0 167 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_805_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8206 22.5697C66.2964 21.102 68.719 21.2039 69.9622 22.8732C71.4173 24.8268 72.7657 26.8678 73.9988 28.9881C80.4028 39.9992 83.4105 52.6546 82.6412 65.3535C81.8719 78.0523 77.3602 90.2246 69.6768 100.331C61.9934 110.437 51.4834 118.023 39.4759 122.131C28.5864 125.855 16.9089 126.567 5.66614 124.223C3.7473 123.823 2.6198 121.872 3.11749 119.976L6.51503 107.034C7.01548 105.127 8.96876 104.006 10.9082 104.357C18.2131 105.679 25.7484 105.122 32.7985 102.71C40.9767 99.913 48.1351 94.746 53.3681 87.8627C58.6012 80.9796 61.674 72.689 62.1979 64.0399C62.722 55.391 60.6735 46.7716 56.3117 39.272C55.8417 38.4636 55.347 37.6723 54.8288 36.8988C53.8269 35.4036 53.9409 33.3897 55.2171 32.1205L64.8206 22.5697Z",
    fill: "#194248"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2005 3.29678C46.0727 2.27674 42.6089 1.05154 40.0027 0.180073C38.0972 -0.457107 36.0697 0.655236 35.5388 2.59307L32.0617 15.2839C31.5538 17.1376 32.6097 19.0586 34.4274 19.6832C36.0418 20.2379 37.8976 20.9189 39.1133 21.5016C40.476 22.155 41.7976 22.8772 43.0736 23.6642C44.6886 24.6603 46.8224 24.3979 48.0176 22.9241L56.4186 12.5655C57.6893 10.9988 57.4099 8.68134 55.7283 7.56713C53.3322 5.9795 50.818 4.55152 48.2005 3.29678Z",
    fill: "#88D4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.841 170.167C135.359 172.141 133.324 173.309 131.39 172.686C128.745 171.834 125.237 170.636 123.072 169.63C111.554 164.274 101.885 155.622 95.2888 144.77C88.6927 133.917 85.4652 121.351 86.0146 108.661C86.5639 95.9698 90.8652 83.7244 98.3749 73.4729C105.885 63.2213 116.265 55.424 128.204 51.0671C139.025 47.118 150.685 46.1559 161.965 48.2486C163.899 48.6074 165.068 50.5445 164.602 52.4548L161.429 65.4404C160.963 67.3487 159.039 68.503 157.099 68.1946C149.765 67.0291 142.233 67.7463 135.219 70.306C127.088 73.2735 120.017 78.5844 114.903 85.5665C109.788 92.5487 106.859 100.889 106.484 109.532C106.11 118.176 108.308 126.734 112.801 134.126C117.294 141.517 123.879 147.41 131.724 151.058C132.987 151.645 134.921 152.328 136.582 152.876C138.386 153.472 139.463 155.344 139.012 157.189L135.841 170.167Z",
    fill: "#194248"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_805_1726",
    x: 0.986368,
    y: 0,
    width: 165.73,
    height: 176.881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.01363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3875 0 0 0 0 0.3875 0 0 0 0 0.3875 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_805_1726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_805_1726",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcLight);
export default __webpack_public_path__ + "static/media/logoIC_light.3c9bc4281b615c18a810ab69a03854e3.svg";
export { ForwardRef as ReactComponent };